import { render, staticRenderFns } from "./NewSurcharge.vue?vue&type=template&id=74bc34cc"
import script from "./NewSurcharge.vue?vue&type=script&lang=js"
export * from "./NewSurcharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports